export default __webpack_public_path__ + "static/media/Gloves of the Death Master (nm).fd25e74d.jpg";